<template>
    <div id="app">
        <Navbar/>

        <transition name="fade" mode="out-in" appear>
			<router-view/>
		</transition>
        <Footer/>
    </div>
</template>

<script>
import Navbar from './subview/Navbar';
import Footer from './subview/Footer';


export default {
	components: {
        Navbar,
        Footer,

    },
    
}

</script>
<style lang="sass">

@import './css/slick-lightbox.css'
@import './css/slick-theme.css'
@import './css/slick.css'
@import '../node_modules/malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css'
@import './sass/global.sass'


body
    // margin-top: -24px
    // @media (max-width: 768px)
    //     margin-top: 24px






	

</style>



// WEBPACK FOOTER //
// src/App.vue